export default __webpack_public_path__ + "static/media/gift-voucher.91cf815b.png";